<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Presupuestos" primaryKey="idpresupuesto" resource="proyectos" :records="records" :meta="meta"
        :columns="columns" hideActions="true"  hideFilters="true" readonly="true">
        <template v-slot:actions>
          <filter-stats />
        </template>
        <template v-slot:tfoot>
          <tfoot>
            <tr class="border-t">
              <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4">
                <strong>
                  Total
                </strong>
              </td>
              <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4">
                <strong>
                  {{ totalHoras }}
                </strong>
              </td>
              <td></td>
            </tr>
          </tfoot>
        </template>
      </card-list>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CardList from "@/components/Cards/CardList.vue";
import FilterStats from "@/components/Forms/FilterStats.vue";
import ReporteService from "@/services/reporte.service";

export default {
  components: {
    CardList,
    FilterStats
  },

  props: {
    idpersonal: {},
  },

  data() {
    return {
      records: null,
      meta: {},
      totalHoras: "",
      columns: [
        {
          label: 'Proyecto',
          name: 'nombre',
          type: 'STRING'
        },
        {
          label: 'Horas',
          name: 'horas',
          type: 'DECIMAL'
        },
        {
          label: '%',
          name: 'porcentaje',
          type: 'DECIMAL',
          doNotSort: true
        }
      ]
    }
  },

  computed: {
    ...mapState({
      startDateFromState: state => state.filters.startDate,
      endDateFromState: state => state.filters.endDate,
    }),
  },

  mounted: function () {
    this.loadRecords();
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        this.loadRecords();

        ["startDateFromState", "endDateFromState"].forEach(property => {
          this.$watch(
            () => this[property],
            () => {
              this.loadRecords();
            }
          );
        });
      }
    }
  },

  methods: {
    loadRecords() {
      // undefined = FilterStats aún no inicializó; null = histórico (sin filtro de fechas)
      if (
        this.startDateFromState === undefined ||
        this.endDateFromState === undefined
      ) {
        return;
      }

      const params = { ...this.$route.query };
      delete params.startDate;
      delete params.endDate;
      if (this.startDateFromState && this.endDateFromState) {
        params.startDate = this.startDateFromState;
        params.endDate = this.endDateFromState;
      }
      params.idpersonal = this.idpersonal;
      params.filter = this.$route.query.filter;

      ReporteService.horasPorPresupuesto(params)
        .then((data) => {
          const totalHoras = data.meta.totalHoras;
          const records = data.records.map(obj => ({
            ...obj,
            porcentaje: ((parseFloat(obj.horas) / totalHoras) * 100).toFixed(2)
          }));
          this.records = records;
          this.meta = data.meta;
          this.totalHoras = totalHoras;

        })
        .catch((response) => {
          console.log(response);
        });
    },
  }
};
</script>
